export const clinicalTokens = {
  primary: '#26a7e3',
  primaryHover: '#058ac8',
  scoreSelected: '#1c2026',
  badgeBusy: '#26a7e3',
  badgeIdle: '#666666',
  danger: '#ff2529',
  menuDanger: '#f94b53',
  placeholder: '#bababa',
  tableBorder: '#ededed',
  divider: '#e5e7ea',
  tableHead: '#f8f8f8',
  pickerList: '#f7f7f7',
  disabled: '#e1e1e1',
  text: '#333333',
  subText: '#666666',
  muted: '#999999',
  timestamp: '#848484',
  surface: '#ffffff',
  hint: '#cfcfcf',
  // 1대 진행 환자 화면의 입력 상자 테두리와 안내 글자
  canvasBorder: '#a8aeb6',
  canvasHint: '#dbdbdb',
  penButtonBorder: '#000000',
  drawingRow: '#f4f6f8',
  // 태블릿 채점 화면의 영역 진행 표시와 미채점 행 강조
  scoreDone: '#3f9e6b',
  scoreMissing: '#b54747',
  missingRow: '#fdf3f3',
  disabledSoft: '#edeff2',
  scoreFull: '#007ddd',
  toastBg: 'rgba(0, 0, 0, 0.8)',
  progressTrack: '#f2f2f2',
  dDay: '#ff1919',
  fontSize: {
    caption: 11,
    small: 12,
    note: 13,
    body: 14,
    base: 16,
    subtitle: 18,
    title: 20,
    heading: 24,
  },
  // Joy 글자 기본 줄 높이(1.5)로 두면 화면 세로가 늘어 글자 크기마다 줄 높이를 정한다
  lineHeight: {
    body: '17px',
    bodyLoose: '21px',
    subtitle: '21px',
    sheetLabel: '14px',
    sheetValue: '16px',
    base: '19px',
    title: '24px',
    alertTitle: '30px',
  },
} as const;
